import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';
import { serializedModelNameEquals } from './utils';

export const MODELS = [
  'gemini-2.5-pro',
  'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  'gemini-2.0-flash',
  'gemini-2.0-flash-exp',
  'gemini-1.5-pro',
  'gemini-1.5-flash',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'gemini-1.5-flash';

export function useChatGoogleGenerativeAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatGoogleGenerativeAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    (!serializedModelNameEquals(serializedModel, 'googlegenerativeai') &&
      params?.ls_provider !== 'google_genai') ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain_google_genai', 'chat_models', 'ChatGoogleGenerativeAI'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model: params.ls_model_name,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      google_api_key: {
        lc: 1,
        type: 'secret',
        id: ['GOOGLE_API_KEY'],
      },
    },
  };
}
